import { PlusOutlined } from '@ant-design/icons';
import * as Unicons from '@iconscout/react-unicons';
import Pagination from '@material-ui/lab/Pagination';
import { Button, Modal, notification } from 'antd';
import { ChangeEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NewMenu from "../../components/NewMenu";
import { useGlobalContext } from '../../context/GlobalContext';
import '../../global.css';
import { IHoraSedeCustomDTO, IHoraSedeDTO, IHoraSedeFullDTO, ILogCleanDTO } from '../../models/happy-code-api.model';
import { Predicate } from '../../models/predicate.model';
import { PageableResponse } from '../../models/response.model';
import { useHoraSedeService } from '../../services/hora-sede.service';
import { useLogService } from '../../services/log.service';
import './style.css';
import FiltroHoraSede from './filtros-hora-sede';
import ItemListHoraSede from './item-lista';
import { useHoraSedeContext } from '../../context/HoraSedeContext';
import { Menu, Dropdown } from "antd";
import { useNotificationService } from '../../services/notification.service';





const HoraSede: React.FunctionComponent = () => {

  const { removeHoraSede, setRevisao, setHoraSede } = useHoraSedeContext();
  const [data, setData] = useState<PageableResponse<IHoraSedeCustomDTO>>();
  const [predicate] = useState<Predicate>(new Predicate());
  const horaSedeService = useHoraSedeService();
  const { setIsGlobalLoading } = useGlobalContext();
  const notification = useNotificationService();
 

  const colunasPersonalizadas: Record<string, string> = {
    id: "ID",
    nomeHora: "Tipo da Licença",

    horaUnidades: "Unidades" ,

    valorSugerido: "Valor Sugerido" ,
    numeroMaximoParcela:"Nº Máx. Parcelas",
    numeroProrrogacaoDiasMatricula:"Nº Pror.dias Matricula",

    splitUmHoraEMeia: "Split Distrito 1h30",
    splitTresHoras: "Split Distrito 3h",
    splitQuatroHorasEMeia: "Split Distrito 4h30",
    splitSeisHoras: "Split Distrito 6h",
    splitAdicional: "Split Distrito Adicional",

    splitUmHoraEMeiaCapital: "Split Capital 1h30",
    splitTresHorasCapital: "Split Capital 3h",
    splitQuatroHorasEMeiaCapital: "Split Capital 4h30",
    splitSeisHorasCapital: "Split Capital 6h",
    splitAdicionalCapital: "Split Capital adicional",
 

    flTaxa: "Taxa",
    valorSplitTaxa:"Valor Taxa Split",

    
    splitColonia: "Split Distrito Colônia",
    splitColoniaCapital: "Split Colônia Capital",
    
    splitEscola: "Split Distrito Escola",
    splitEscolaCapital: "Split Escola Capital",
    
    splitCurta:"Curta Distrito",
    splitCurtaUmHoraEMeia: "Curta Distrito 1h30",
    splitCurtaTresHoras: "Curta Distrito 3h",
    splitCurtaQuatroHorasEMeia: "Curta Distrito 4h30",
    splitCurtaSeisHoras: "Curta Distrito 6h",
    splitCurtaMaiorSeisHoras: "Curta Distrito > 6h",
    
    splitUpgradeUmaHoraEMeia: "Upgrade Distrito 1h30",
    splitUpgradeTresHoras: "Upgrade Distrito 3h",
    splitUpgradeQuatroHorasEMeia: "Upgrade Distrito 4h30",
    splitUpgradeSeisHoras: "Upgrade Distrito 6h",
    splitUpgradeMaiorSeisHoras: "Upgrade Distrito > 6h",
    splitAdicionalUpgrade: "Upgrade Distrito Adicional",
    
    splitUpgradeUmaHoraEMeiaCapital: "Upgrade Capital 1h30",
    splitUpgradeTresHorasCapital: "Upgrade Capital 3h",
    splitUpgradeQuatroHorasEMeiaCapital: "Upgrade Capital 4h30",
    splitUpgradeSeisHorasCapital: "Upgrade Capital 6h",
    splitUpgradeMaiorSeisHorasCapital: "Upgrade Capital > 6h",
    splitAdicionalUpgradeCapital: "Upgrade Adicional Capital",
   
    dataCriacao:"Data Split Gerado",
    dataAtualizacao:"Data Split Atualizada",
    usuario: "Usuário da Última Alteração",
  };

  const findHoraSede = () => {
    setIsGlobalLoading(true);
    horaSedeService.findCustom(predicate)
      .then(({ data }) => {
        setData(data)
        console.log(data);

      })
      .finally(() => setIsGlobalLoading(false));
  };

  const handleCampanha = (hora: IHoraSedeFullDTO, state: boolean) => {
    Modal.confirm({
      title: `Deseja realmente ${state ? 'ativar' : 'inativar'} a configuração?`,
      icon: <Unicons.UilExclamationCircle />,
      content: hora.nomeHora,
      okText: 'Sim',
      okType: state ? 'primary' : 'danger',
      cancelText: 'Não',
      onOk: () => {
        setIsGlobalLoading(true);
        horaSedeService
          .patchAtivo(hora.id, state) 
          .then(() => {
            notification({
              type:'success',
              message: 'Sucesso',
              description: 'Configuração atualizada com sucesso!',
            });
            findHoraSede(); 
          })
          .catch(() => {
            notification({
              type:'error',
              message: 'Erro',
              description: 'Não foi possível atualizar a configuração.',
            });
          })
          .finally(() => setIsGlobalLoading(false));
      },
    });
  };
  
  const gerarMenu = (hora, handleCampanha: (hora: IHoraSedeFullDTO, state: boolean) => void) => (
    <Menu>
      <Menu.Item onClick={() => handleCampanha(hora, !hora.ativo)}>
        <a rel="noopener noreferrer">
          {hora.ativo ? "Inativar hora" : "Ativar hora"}
        </a>
      </Menu.Item>
    </Menu>
  );


  const history = useHistory();

  const logService = useLogService();
  const [log] = useState<ILogCleanDTO>({
    descricaoEvento: "Acesso negocios",
    descricaoTipo: "Acesso a tela",
    idTipo: null,
    id: null,
    descricaoUsuario: null,
    ativo: true
  });


  const goTo = (hora: IHoraSedeCustomDTO) => {
    setIsGlobalLoading(true);
    horaSedeService.findFullById({id: hora?.id})
    .then(({ data }) => {
      setHoraSede(data); 
    })
    
      .finally(() => {
        setIsGlobalLoading(false)
        history.push(`/hora/create/step-6`)
      });
  }
  useEffect(() => {
    removeHoraSede();
    setRevisao(false);
  }, []);

  useEffect(() => {
    logService.registraLog(log);
  }, []);

  useEffect(() => {
    logService.registraLog(log);
  }, []);



  const onPageChange = (event: ChangeEvent<any>, page: number) => {
    event.preventDefault();
    predicate.setPage(page);
    findHoraSede();
  };

  const goToAdd = () => {
    history.push("/hora/create/step-1");
  };


  return (

    <div className="tabela" style={{ display: "flex", width: '100%' }}>
      <NewMenu selecionado={97} />

      <div className="dashboard-horasede" style={{ flex: 1, overflow: 'hidden' }}>
        <div className="box-title">
          <h3 className="title">Registros ({data?.totalElements})</h3>
          <Button
            className="button-primary"
            id="criar-campanha"
            icon={<PlusOutlined rev={undefined} />}
            onClick={goToAdd}
          >
            Criar Configuração
          </Button>
        </div>
        <FiltroHoraSede findHoraSede={findHoraSede} predicate={predicate} />

        {/* Contêiner Principal */}
        <div className="tabela-container">
          {/* Tabela com Scroll Horizontal */}
          <div className="tabela-scroll">
            {/* Cabeçalho da Tabela */}
            <div className="tabela-header">
              {Object.keys(colunasPersonalizadas).map((key, index) => (
                <div
                  key={index}
                  className="item-header"
                  style={{ minWidth: "200px", maxWidth: "250px" }}
                >
                  {colunasPersonalizadas[key]}
                </div>
              ))}
            </div>

            {/* Corpo da Tabela */}
            <div className="tabela-body">
              {data?.content?.map((hora, index) => (
                <ItemListHoraSede
                  key={index}
                  hora={hora}
                  handleCampanha={handleCampanha}
                />
              ))}
            </div>
          </div>

          {/* Coluna de Ações (Fixa no Lado Direito) */}
          <div className="tabela-acoes ">

            {data?.content?.map((hora, index) => (
              <div key={index} className={`acoes-item registro-user linha-${index}`}>
                <a id="editar" onClick={() => goTo(hora)}>
                  <Unicons.UilEdit size="20" color="#92A9CB" style={{ marginRight: "10px", cursor: "pointer" }} />
                </a>
                <Dropdown overlay={gerarMenu(hora, handleCampanha)} placement="bottomRight" arrow>
                  <Unicons.UilEllipsisH className="button-dropdown" size="20" color="#92A9CB" />
                </Dropdown>
              </div>
            ))}
          </div>

        </div>
        {/* Paginação */}
        <div className="paginacao">
          <Pagination
            onChange={(event, page) => onPageChange(event, page - 1)}
            page={data ? data.pageable.pageNumber + 1 : 0}
            count={data ? data.totalPages : 0}
          />
        </div>
      </div>

    </div>
  );

}

export default HoraSede;